// Angular
import { Injectable } from '@angular/core';

// Libraries
import { takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from 'file-saver';

// Services
import { AppCleanup } from '../../../shared/models';
import { JobService } from './job.service';
import { SpinnerService } from '../../../shared/components/spinner/services/spinner.service';

// Models
import { JobAttachmentViewModel } from '../models/job-attachment.model';

// Components
import { FileUploadDialogComponent, FileUploadSettings } from '../../../shared/dialogs/file-upload-dialog/file-upload-dialog.component';
import { ImageDisplayDialogComponent } from '../../../shared/dialogs/image-display-dialog/image-display-dialog.component';

@Injectable({
	providedIn: 'root',
})
export class JobAttachmentService extends AppCleanup {
	constructor(
		private dialog: MatDialog,
		private jobService: JobService,
		private spinnerService: SpinnerService
	) {
		super();
	}

	showImageDisplayModal(jobId: number, jobAttachment: JobAttachmentViewModel, isPublic: boolean, linkGuid: string) {
		this.spinnerService.showAppSpinner();
		let base64Image: string;

		if (!isPublic) {
			this.jobService
				.getJobAttachmentAsBase64(jobId, jobAttachment?.id)
				.pipe(takeUntil(this.destroy))
				.subscribe((file) => {
					base64Image = file.base64String;
					this.spinnerService.hideAppSpinner();
					openDialog();
				});
		} else {
			this.jobService
				.getPublicJobAttachmentAsBase64(linkGuid, jobAttachment?.id)
				.pipe(takeUntil(this.destroy))
				.subscribe((file) => {
					base64Image = file.base64String;
					this.spinnerService.hideAppSpinner();
					openDialog();
				});
		}

		let openDialog = () => {
			const dialogRef = this.dialog.open(ImageDisplayDialogComponent, {
				data: {
					title: jobAttachment?.fileName,
					base64Image: base64Image,
					downloadable: true,
				},
				width: '100%',
				maxWidth: '600px',
				panelClass: 'comment-add-dialog-wrap',
				autoFocus: false,
			});

			dialogRef
				.afterClosed()
				.pipe(takeUntil(this.destroy))
				.subscribe(() => {});
		};
	}

	openImageOrDownloadFile(jobAttachment: JobAttachmentViewModel, isPublic: boolean, linkGuid: string) {
		if (jobAttachment.isImage) {
			this.showImageDisplayModal(jobAttachment.jobId, jobAttachment, isPublic, linkGuid);
		} else {
			this.jobService
				.downloadJobAttachment(jobAttachment.jobId, jobAttachment.id)
				.pipe(takeUntil(this.destroy))
				.subscribe((result) => {
					let filename = jobAttachment.fileName;
					var blob = new Blob([result]);
					saveAs(blob, filename);
				});
		}
	}

	openFileUploadDialog() {
		let uploadSettings: FileUploadSettings = new FileUploadSettings();
		uploadSettings.allowedExtensions = ['.png', '.jpg', '.jpeg', '.csv', '.pdf', '.doc', '.docx', '.xlsx', '.xls'];
		uploadSettings.maxSize = 1024 * 1024 * 50;

		return this.dialog.open(FileUploadDialogComponent, {
			data: {
				uploadSettings: uploadSettings,
			},
			width: '100%',
			maxWidth: this.isViewer ? '500px' : '450px',
			autoFocus: false,
		});
	}
}
